// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"1334a032","839":"bd643e0f","883":"9a859b61"}[chunkId] + ".chunk.js";
};